<template>
  <div v-if="open" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">

    <div class="bg-white w-full max-w-xl rounded-2xl shadow-xl p-8 relative">

      <!-- Header -->
      <div class="mb-6">
        <h2 class="text-2xl font-extrabold">Basic Information</h2>
        <p class="text-slate-500 text-sm mt-1">
          Help creators understand their audience better.
        </p>
      </div>

      <form class="space-y-5" @submit.prevent.stop="submitProfile">

       <div class="two-col">
            <!-- Gender -->
            <div>
                <label class="form-label">Gender</label>
                <select v-model="form.gender" class="form-input">
                <option value="">Select</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="non_binary">Non-binary</option>
                </select>
            </div>

            <!-- Age Range -->
            <div>
                <label class="form-label">Age Range</label>
                <select v-model="form.age_range" class="form-input">
               <option value="">Select</option>
                <option value="13-17">13–17</option>
                <option value="18-24">18–24</option>
                <option value="25-34">25–34</option>
                <option value="35-44">35–44</option>
                <option value="45_plus">45+</option>
                </select>
            </div>
        </div>

        <!-- Occupation -->
        <div>
          <label class="form-label">Occupation</label>
          <select v-model="form.occupation" class="form-input">
            <option value="">Select</option>
            <option value="Student">Student</option>
            <option value="Working Professional">Working Professional</option>
            <option value="Business Owner">Business Owner</option>
            <option value="Freelancer">Freelancer</option>
            <option value="Homemaker">Homemaker</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <!-- Income -->
        <div>
          <label class="form-label">Annual Personal Income</label>

          <div class="grid grid-cols-2 gap-2 text-sm">
            <label v-for="i in incomeOptions" :key="i" class="radio-card">
              <input type="radio" :value="i" v-model="form.income" />
              <span>{{ i }}</span>
            </label>
          </div>
        </div>

        <div class="two-col">
            <!-- City Tier -->
            <div>
            <label class="form-label">City Tier (Optional)</label>
            <select v-model="form.city_tier" class="form-input">
                <option value="">Select</option>
                <option value="tier_1">Tier 1 (Metro Cities)</option>
                <option value="tier_2">Tier 2</option>
                <option value="tier_3">Tier 3</option>
                <option value="rural">Rural</option>
            </select>
            </div>

            <!-- Social Platform -->
            <div>
            <label class="form-label">Primary Social Platform</label>
            <select v-model="form.platform" class="form-input">
                <option value="">Select</option>
                <option value="instagram">Instagram</option>
                <option value="youtube">YouTube</option>
                <option value="tiktok">TikTok</option>
                <option value="x">X</option>
                <option value="other">Other</option>
            </select>
            </div>
        </div>

        <!-- Country -->
        <div>
          <label class="form-label">Country (Optional)</label>
          <input
            v-model="form.country"
            type="text"
            class="form-input"
            placeholder="India"
          />
        </div>

        <!-- Submit -->
        <button
          class="w-full bg-primary text-white font-bold py-3 rounded-lg hover:bg-black transition"
        >
          Save & Continue
        </button>

      </form>

    </div>
  </div>
</template>

<script>
import { saveBasicProfileApi } from "@/apis/fanapis";
import { useToast } from "vue-toastification";

export default {
  props: {
    open: Boolean
  },

  data() {
    return {
      toast:null,
      form: {
        gender: "",
        age_range: "",
        occupation: "",
        income: "",
        city_tier: "",
        platform: "",
        country: ""
      },

      incomeOptions: [
        "No Income",
        "₹0 – ₹2,50,000",
        "₹2,50,000 – ₹5,00,000",
        "₹5,00,000 – ₹10,00,000",
        "₹10,00,000 – ₹20,00,000",
        "₹20,00,000+"
      ]
    };
  },
  mounted(){
    this.toast = useToast();
  },
  methods: {
    async submitProfile() {

      try {

        const ldataRaw = sessionStorage.getItem("ldata");
        const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
        const user_id = ldata.user_id;

        if(!user_id){
            this.toast.error("User session missing");
            return;
        }

        // ✅ Basic Validation
        if(!this.form.gender){
            this.toast.error("Please select gender");
            return;
        }

        if(!this.form.age_range){
            this.toast.error("Please select age range");
            return;
        }

        if(!this.form.occupation){
            this.toast.error("Please select occupation");
            return;
        }

        if(!this.form.income){
            this.toast.error("Please select income range");
            return;
        }

        if(!this.form.platform){
            this.toast.error("Please select primary social platform");
            return;
        }

        const res = await saveBasicProfileApi({
          user_id: user_id,
          gender: this.form.gender,
          age_range: this.form.age_range,
          occupation: this.form.occupation,
          income: this.form.income,
          city_tier: this.form.city_tier,
          platform: this.form.platform,
          country: this.form.country
        });

        if(res.status){
          this.$emit("submit", this.form);
        }else{
          this.toast.error(res.success || "Something went wrong");
        }
      } catch(e){
        this.toast.error("Server error");
      }
    }
  }
};
</script>

<style scoped>
/* Reduce vertical spacing inside form */
form.space-y-5 > div{
  margin-bottom: 10px;
}

/* Header tighter */
.mb-6{
  margin-bottom: 14px !important;
}

/* Labels smaller + closer to inputs */
.form-label{
  font-size:10px;
  font-weight:700;
  text-transform:uppercase;
  color:#64748b;
  margin-bottom:2px;
  display:block;
  letter-spacing:0.02em;
}

/* Compact inputs */
.form-input{
  width:100%;
  border:1px solid #e5e7eb;
  padding:7px 9px;     /* reduced from 10px */
  border-radius:8px;   /* slightly smaller */
  background:#f8fafc;
  font-size:13px;
  height:34px;         /* fixed compact height */
}

/* Income radio grid tighter */
.grid.grid-cols-2{
  gap:6px !important;
}

/* Radio card smaller */
.radio-card{
  display:flex;
  gap:5px;
  align-items:center;
  border:1px solid #e5e7eb;
  padding:4px 6px;
  border-radius:6px;
  cursor:pointer;
  font-size:12px;
}

/* Reduce radio size slightly */
.radio-card input{
  transform:scale(0.9);
}

/* Button smaller */
button{
  padding:10px 14px !important;
  font-size:14px;
}
.two-col{
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:10px;
}
</style>